export * from './input-accept-type';
